import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { ProductCode } from "../../../../product/product.model";
import { OfferBundlePreview } from "../../../models/offer-bundle-preview.model";
import { OfferBundlesSummary } from "../../../models/offer-bundles-summary.model";
import { OfferProductIds } from "../../../models/offer-action-ids.model";
import { LargeLoanProgramName } from "../../../models/large-loan-program.model";

@Component({
    selector: "ifc-offer-product-navigation",
    templateUrl: "./offer-product-navigation.component.html",
    styleUrls: ["./offer-product-navigation.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class OfferProductNavigationComponent implements OnChanges {
  @Input() offerBundlesSummary: OfferBundlesSummary;

  readonly largeLoanProgramName = LargeLoanProgramName;

  isCurrentLocProduct: boolean;
  isCurrentLargeLoanProgramProduct: boolean;
  isCurrentLawProduct: boolean;
  isCurrentTermProduct: boolean;

  @Output()
  changeOffer = new EventEmitter<OfferProductIds>();

  ngOnChanges(): void {
    const currentOfferBundle = this.offerBundlesSummary?.currentOfferBundle;
    const currentProduct = currentOfferBundle?.productCode;

    this.isCurrentLocProduct = currentProduct === ProductCode.LOC && !currentOfferBundle.largeLoanProgram;
    this.isCurrentLargeLoanProgramProduct = currentProduct === ProductCode.LOC && currentOfferBundle.largeLoanProgram;
    this.isCurrentLawProduct = currentProduct === ProductCode.Law;
    this.isCurrentTermProduct = currentProduct === ProductCode.Term;
  }

  onClickProduct(offerBundle: OfferBundlePreview) {
    const data: OfferProductIds = {
      offerId: offerBundle.offerBundleId,
      productCode: offerBundle.productCode,
    };
    this.changeOffer.emit(data);
  }
}
